export default __webpack_public_path__ + "static/media/pichot-logo-new.abb14438.jpg";